import { createReducer } from '@reduxjs/toolkit';
import { AsyncStatus } from 'lib-shared-types-api';

import { jabraActions } from './jabra.actions';

export type JabraDevice = {
  deviceName: string;
  isDongleDevice: boolean;
  productId: string;
  serialNumber: string;
  isLocked?: boolean;
};

export type JabraState = {
  meta: {
    list: AsyncStatus;
    ring: AsyncStatus;
    unring: AsyncStatus;
  };
  ui: {
    error: string | Error | null;
  };
  isConnectedToJabra: boolean;
  jabraList: JabraDevice[];
};

const initialState: JabraState = {
  meta: {
    list: 'uninitialized',
    ring: 'uninitialized',
    unring: 'uninitialized',
  },
  ui: {
    error: null,
  },
  isConnectedToJabra: false,
  jabraList: [],
};

export const jabraReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(jabraActions.jabraRing.toString(), (state) => {
      return { ...state, meta: { ...state.meta, ring: 'pending' } };
    })
    .addCase(jabraActions.jabraRingSucceeded.toString(), (state) => {
      return { ...state, meta: { ...state.meta, ring: 'fulfilled' } };
    })
    .addCase(jabraActions.jabraRingFailed.toString(), (state) => {
      return { ...state, meta: { ...state.meta, ring: 'rejected' } };
    })
    .addCase(jabraActions.jabraUnring.toString(), (state) => {
      return { ...state, meta: { ...state.meta, unring: 'pending' } };
    })
    .addCase(jabraActions.jabraUnringSucceeded.toString(), (state) => {
      return { ...state, meta: { ...state.meta, unring: 'fulfilled' } };
    })
    .addCase(jabraActions.jabraUnringFailed.toString(), (state) => {
      return { ...state, meta: { ...state.meta, unring: 'rejected' } };
    })
    .addCase(jabraActions.jabraList.toString(), (state) => {
      return { ...state, meta: { ...state.meta, list: 'pending' } };
    })
    .addCase(
      jabraActions.jabraListSucceeded.toString(),
      (state, action: any) => {
        return {
          ...state,
          meta: { ...state.meta, list: 'fulfilled' },
          ui: {
            error: null,
          },
          jabraList: action?.payload?.list ?? [],
        };
      },
    )
    .addCase(jabraActions.jabraListFailed.toString(), (state, action: any) => {
      return {
        ...state,
        meta: { ...state.meta, list: 'rejected' },
        ui: {
          error: action.payload.error,
        },
        jabraList: [],
      };
    })
    .addCase(jabraActions.jabraClosed.toString(), (state) => {
      return { ...state, jabraList: [] };
    })
    .addCase(jabraActions.jabraAttached.toString(), (state, action: any) => {
      return {
        ...state,
        isConnectedToJabra:
          action.payload && action.payload.connected !== undefined
            ? action.payload.connected
            : state.isConnectedToJabra,
      };
    })
    .addCase(jabraActions.jabraDetached.toString(), (state, action: any) => {
      return {
        ...state,
        isConnectedToJabra:
          action.payload && action.payload.connected !== undefined
            ? action.payload.connected
            : state.isConnectedToJabra,
      };
    }),
);
